import { z } from 'zod';
import { uuid } from './common.js';
export const roleKey = z.string().regex(/^[a-z][a-z0-9_-]{1,29}$/);
export const roleDto = z.object({
    id: uuid,
    key: roleKey,
    label: z.string(),
    caps: z.array(z.string()),
    system: z.boolean(),
    userCount: z.number().int(),
});
export const createRoleRequest = z.object({
    key: roleKey.optional(),
    label: z.string().trim().min(1).max(60),
    caps: z.array(z.string()).default([]),
});
export const updateRoleRequest = z.object({
    label: z.string().trim().min(1).max(60).optional(),
    caps: z.array(z.string()).optional(),
});
//# sourceMappingURL=roles.js.map